<template>
  <login-layout>
    <div class="text-center">

      <div v-if="processing">
        <h3>Your attendance is being confirmed</h3>
        <p>Please wait...</p>
      </div>

      <div v-if="!processing && success" >
        <h3>Thank You!</h3>
        <p>You have been confirmed as attending.</p>
        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

      <div v-if="!processing && !success" >
        <h3>Unable To Confirm Attendance</h3>

        <p>
          Sorry we were unable to confirm your attendance.
        </p>

        <div class="flex w-full justify-center">
          <a href="/" class="btn btn-dark">
            Continue to Dashboard
          </a>
        </div>
      </div>

    </div>
  </login-layout>
</template>

<script>
import LoginLayout from './auth/LoginLayout'

export default {
  components: {
    LoginLayout
  },

  props: {
    token: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      processing: true,
      success: false,
      error: null
    }
  },

  mounted () {
    this.$http.put('confirm-attendance', { token: this.token }).then(response => {
      this.processing = false
      this.success = true
    }).catch(error => {
      this.processing = false
      this.error = error.response
    })
  }

}
</script>
